export const apiurls ={
  Login: "/login",
  ResetPassword: "/reset-password",
  ForgotPassword: "/forgot-password",
  Logout: "/logout",
  Registration: "/api/registration",
  GetCountry: "/get-countries",
  GetUni: "/get-universities?country_code=US",
  CodeValid: "/api/book-code-validation",
  ValidEmail: "/api/validate-email",
  ValidUsername: "/api/check-username",
  GenCodeApi:"/generate-codes",
  ResourceList:'/get-resource-list',
  ValidateToken: "/validate-token",
  UserDetails: "/api/get-user-details",
  UserList: "/get-user-list",
  Feedback: "/feedback",
  ResourceDetails: "/get-resource-details",
  UpdateUsers: "/api/update-user-details/",
  ActivationValidity: "/api/check-activation-validity/",
  ResendActivationValidity: "/api/resend-activation-link",
  ContactUs: "/contact-us",
  GetStates: "/get-states",
  GetStateUni : "/get-universities",
  ResendEmail: "/resend_email",
	ResourceUpdate: "/update-resource",
  AdminDashboard:"/get-dashboard-data",
  FeedbackGiven: "/is-feedback-given/",
  GetTopics: "/get-topics",
  GetVideo: "/get-video",
  UniversityListing: "/university-master-list",
  AddUniversity: "/add-new-university",
  FeedbackAnalysis: "/feedback-analysis",
  GetConsentDocuments: "/get-consent-documents",
  UploadDocuments: "/upload-documents",
  GetDoc: "/get-document/",
  SettingsDetails: "/get-settings-details",
  SaveSettings: "/update-settings-details",
  CronSettings: "/crons/get-cron-settings",
  ExportListingData: "/export-data"
}
